import { UserRole } from '../../models/general.models';
export var isAppReady = function (_a) {
    var isWalkThroughCompleted = _a.isWalkThroughCompleted, isAuthenticated = _a.isAuthenticated, isCountryCompleted = _a.isCountryCompleted, isMemberRegistryCompleted = _a.isMemberRegistryCompleted;
    return isWalkThroughCompleted !== undefined &&
        isAuthenticated !== undefined &&
        isCountryCompleted !== undefined &&
        isMemberRegistryCompleted !== undefined;
};
/**
 * Risolve il ruolo utente a partire dai dati già caricati. Restituisce
 * `undefined` finché i dati necessari non sono disponibili: in quel caso il
 * provider continua a mostrare il Loader.
 *
 * `hasRedeemCode` dice soltanto che nel localStorage c'è un codice *da
 * riscattare*: non è una prova di pagamento (il codice viene salvato dal query
 * param prima di qualsiasi validazione lato server) e non può quindi produrre un
 * ruolo che dà accesso ai contenuti a pagamento. L'unico segnale di entitlement
 * è `userPaymentNeeded`, che deriva dalla subscription del family leader e da
 * Qonversion: dopo un riscatto valido è il server a marcare la subscription come
 * `AUTHORIZED`. Il codice pendente serve solo a instradare l'utente sul flusso di
 * riscatto prima che il profilo esista.
 */
export var resolveUserRole = function (inputs) {
    if (!isAppReady(inputs)) {
        return undefined;
    }
    if (!inputs.isAuthenticated) {
        return UserRole.Anonymous;
    }
    if (inputs.hasRedeemCode && !inputs.hasPerson) {
        return UserRole.AnonymousCouponRedeemUser;
    }
    if (!inputs.isCountryCompleted) {
        return UserRole.NoCountryUser;
    }
    if (!inputs.isMemberRegistryCompleted) {
        return UserRole.PartialUser;
    }
    if (inputs.userPaymentNeeded) {
        return UserRole.UserPaymentNeeded;
    }
    return inputs.isPlanCreated
        ? UserRole.CompleteUser
        : UserRole.PlanPendingUser;
};
